/*eslint-disable*/
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Button } from "@material-ui/core";
import Lottie from "react-lottie";
// import LottieNotHours from "../../../../animations/notime_workintime.json";
import LottieNoTFound from "../../../../animations/lottie_not_found.json";

const useStyles = makeStyles((theme) => ({
  gridMain: {
    height: "300px",
    margin: "auto",
    // backgroundColor: "red",
  },
}));

export default function NotHoursLogged(props) {
  const classes = useStyles();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LottieNoTFound,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      className={classes.gridMain}
    >
      <Grid container direction="column" alignItems="center">
        <Lottie options={defaultOptions} height={130} width={140} />
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 26,
            fontWeight: 500,
            color: "#fff",
          }}
        >
          Sin registro de horas
        </Typography>
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 18,
            color: "#acacac",
          }}
        >
          No se han registrado horas en los filtros seleccionados
        </Typography>
      </Grid>
    </Grid>
  );
}
